export const downloadFile = (href: string) => {
    const link = document.createElement('a')
    link.href = href
    link.setAttribute('download', "")
    document.body.appendChild(link)
    link.click()
    link.remove()
}